<template>
  <v-row  justify="center">
      <v-card class="pa-3" width="320px">
        <v-card-text >
          <slot></slot>
        </v-card-text>
      </v-card>
  </v-row>
</template>

<script>
export default {
  name: 'FhCard'
}
</script>

<style scoped>

</style>
